import * as React from "react";
import Header from "./Header";
import { UploadFile } from "../handlefile/UploadFile";

export default function LayoutUpload() {
  return (
    <>
      <Header />
      <UploadFile />
    </>
  );
}
